module.exports = __webpack_public_path__ + "img/spinning.ca5c8fe8.svg";